export default __webpack_public_path__ + "static/media/newNotify.1889674a.mp3";